import { DomHelper } from "./domHelper";
import { sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
import { marked } from 'marked';
export function appKiDialog(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appKiDialog");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        if (DEBUG)
            console.log("Ki Dialog handleClick");
        handleClickOpen(cardNode, username, bearerToken, userResponse.odDeskPreferences, app);
    });
}
export function appKiFlex(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appKiFlex");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-ki-flex');
        injectNode.innerHTML = content;
        createButtonOpenKiFlex(injectNode, username, bearerToken, userResponse.odDeskPreferences, app);
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
}
export function appKiSummarize(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appKiSummarize");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-ki-sum');
        injectNode.innerHTML = content;
        createButtonOpenKiSum(injectNode, username, bearerToken, userResponse.odDeskPreferences, app, 'rudi-ki-sum-btn-show', 'summary', "Text zusammenfassen");
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
}
export function appKiSimple(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appKiSimple");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-ki-simple');
        injectNode.innerHTML = content;
        createButtonOpenKiSum(injectNode, username, bearerToken, userResponse.odDeskPreferences, app, 'rudi-ki-simple-btn-show', 'simple', 'Text vereinfachen');
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
}
function appPartResultRender(resultNode, usertag, message, system, tokenCount) {
    if (DEBUG)
        console.log("-->appKiDialog", tokenCount);
    const htmlContent = marked(message);
    const divNode = DomHelper.appendNode(resultNode, 'div', [system], [], '');
    DomHelper.appendNode(divNode, 'p', ['nametag', system], [], usertag);
    if (usertag != "Du") {
        const iconCopyNode = DomHelper.appendNode(divNode, 'i', ['fa-light', 'fa-copy'], []);
        iconCopyNode.addEventListener('click', (e) => {
            navigator.clipboard.writeText(message);
        });
    }
    const messageNode = DomHelper.appendNode(divNode, 'p', ['message'], []);
    if (typeof (htmlContent) == "string")
        messageNode.innerHTML = htmlContent;
    if (tokenCount && tokenCount > 2500) {
        DomHelper.appendNode(divNode, 'p', ['hint'], [], "Du hast jetzt schon viele Fragen in einer Session gestellt. Jede weitere Frage erhöht <em>Kosten- und Energieaufwand</em>.<br>Wenn Du bereits Fragen zu einem neuen Thema stellst wäre es besser den Chatverlauf zu leeren und von vorne zu beginnen.");
    }
    messageNode.scrollIntoView();
}
function storeChatSession(sessionID, history) {
    let sessionString, session;
    try {
        sessionString = localStorage.getItem(sessionID);
        if (sessionString)
            session = JSON.parse(sessionString);
        session.push(history);
        localStorage.setItem(sessionID, JSON.stringify(session));
        return session;
    }
    catch (e) {
        localStorage.setItem(sessionID, JSON.stringify([history]));
        return [history];
    }
}
function appendHistoryNode(listNode, historyObj, insertBefore = false) {
    var _a;
    if (DEBUG)
        console.log('appendHiostoryNode', insertBefore, historyObj);
    let listElement;
    if (insertBefore)
        listElement = DomHelper.appendNodeFirstChild(listNode, 'li', [], [{ attr: 'historyid', value: historyObj.key }]);
    else
        listElement = DomHelper.appendNode(listNode, 'li', [], [{ attr: 'historyid', value: historyObj.key }]);
    DomHelper.appendNode(listElement, 'span', [], [], Util.isoString2DateString(historyObj.value[0].timestamp));
    DomHelper.appendNode(listElement, 'span', [], [], ((_a = historyObj.value[0].content) === null || _a === void 0 ? void 0 : _a.substring(0, 20)) + '...');
    listElement.addEventListener('click', function (event) {
        const id = listElement.getElementsByClassName('historyid');
        const resultNode = document.getElementById('odKiResult');
        const inputNode = document.getElementById('odKiPromptInput');
        inputNode.value = '';
        inputNode.setAttribute('session', historyObj.key);
        resultNode.innerHTML = '';
        for (let historyElement of historyObj.value) {
            appPartResultRender(resultNode, historyElement.role == 'system' ? 'RuDi#KI' : 'Du', historyElement.content, historyElement.role);
        }
    });
}
function createResetButton(historyNode, historyList, listNode) {
    const buttonResetNode = DomHelper.appendNode(historyNode, 'button', ['btn', 'btn-secondary', 'ms-2', 'mt-2', 'mb-2'], [{
            attr: 'id',
            value: 'kiHistoryReset'
        }]);
    DomHelper.appendNode(buttonResetNode, 'i', ['fa-light', 'fa-broom-wide'], []);
    DomHelper.appendNode(buttonResetNode, 'span', [], [], 'Verlauf leeren');
    buttonResetNode.addEventListener('click', function (event) {
        for (let historyObj of historyList) {
            localStorage.removeItem(historyObj.key);
            const item = listNode.querySelector(`li[historyid='${historyObj.key}']`);
            if (item)
                item.remove();
        }
        buttonResetNode.remove();
    });
}
function renderHistory(historyNode) {
    historyNode.innerHTML = '';
    const listNode = DomHelper.appendNode(historyNode, 'ul', [], []);
    let historyList = [];
    for (let i = 0, l = localStorage.length; i < l; i++) {
        let key = localStorage.key(i);
        if (key && key.startsWith('KI-') && localStorage.getItem(key) != null) {
            const valueItem = JSON.parse(localStorage.getItem(key));
            const historyObj = { key: key, value: valueItem };
            historyList.push(historyObj);
        }
    }
    historyList.sort(function (a, b) {
        let objA = a.value[0];
        let objB = b.value[0];
        return new Date(objB.timestamp).getTime() - new Date(objA.timestamp).getTime();
    });
    for (let historyObj of historyList) {
        appendHistoryNode(listNode, historyObj);
    }
    if (historyList.length > 1) {
        createResetButton(historyNode, historyList, listNode);
    }
}
function createButtonOpenKiSum(injectNode, username, bearerToken, userPreferences, app, buttonId, endpoint, pageTitle) {
    const additionalClassList = [];
    const buttonNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    buttonNode.addEventListener('click', function (event) {
        if (buttonNode) {
            const appGroupNode = document.getElementById('appGroups');
            if (appGroupNode)
                appGroupNode.classList.add('disabled');
            const fullScreenNode = document.getElementById('appFullscreen');
            if (fullScreenNode) {
                const appConfig = JSON.parse(app.odAppConfig);
                fullScreenNode.classList.remove('disabled');
                let sessionID = 'KI--' + Util.generateRandomDomId();
                createButtonClose(fullScreenNode, username, bearerToken, userPreferences);
                DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], appConfig.title ? appConfig.title : pageTitle);
                const mainNode = DomHelper.appendNode(fullScreenNode, 'section', [], [], "", "odChatSection");
                const promptNode = DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiPromptSum");
                const resultNode = DomHelper.appendNode(mainNode, 'section', ['response-area'], [], "", "odKiResultSum");
                DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiHelp");
                const formNode = DomHelper.appendNode(promptNode, 'section', [], [{ attr: 'id', value: "kiPrompt" }, { attr: 'session', value: sessionID }]);
                const placeholderText = 'Kopiere hierhin Deinen Text ...';
                const inputNode = DomHelper.appendNode(formNode, 'div', [], [
                    { attr: 'type', value: 'text' },
                    { attr: 'session', value: sessionID },
                    { attr: 'placeholder', value: placeholderText },
                    { attr: 'contenteditable', value: 'true' },
                    { attr: 'id', value: 'odKiPromptInput' }
                ], placeholderText);
                inputNode.addEventListener('focus', function (event) {
                    if (inputNode.innerText === placeholderText)
                        inputNode.innerText = '';
                });
                const uploadNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
                DomHelper.appendNode(uploadNode, 'label', ['form-label'], [{ attr: 'for', value: 'words-input' }], 'ungefähre Anzahl Wörter im Ergebnis');
                const inputWordsNode = DomHelper.appendNode(uploadNode, 'input', ['form-control', 'ms-1'], [{ attr: 'type', value: 'number' }, { attr: 'value', value: '100' }], '', 'words-input');
                const buttonNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-primary', 'ms-1'], [{ attr: 'id', value: 'kiPromptSubmit' }]);
                DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-paper-plane'], []);
                buttonNode.addEventListener('click', function (event) {
                    const inputPrompt = (inputNode).innerText;
                    if (inputPrompt.length < 1)
                        return;
                    const currentDate = new Date();
                    const requestObject = {
                        persona: {
                            cn: appConfig.persona ? appConfig.persona : "kibp_assistent"
                        },
                        template: {
                            cn: appConfig.template ? appConfig.template : "kibt_completion"
                        },
                        maxWords: Number(inputWordsNode.value),
                        model: {
                            cn: appConfig.model ? appConfig.model : "mistral-large-latest"
                        },
                        textInput: inputPrompt
                    };
                    let currentSession = inputNode.getAttribute('session') + '';
                    const spinNode = DomHelper.appendNode(resultNode, 'i', ['fa-light', 'fa-spinner-third', 'fa-spin'], [], '', 'ki-spinner');
                    buttonNode.classList.add('disabled');
                    const url = `/kibot/${endpoint}`;
                    try {
                        sendBackendData('', url, 'POST', 'application/json', bearerToken, requestObject, function (response) {
                            const responseData = JSON.parse(response.target.response);
                            spinNode.remove();
                            appPartResultRender(resultNode, responseData.role == 'system' ? 'RuDi#KI' : 'Zusammenfassung', responseData.content, 'system', responseData.tokenCount);
                        });
                    }
                    catch (e) {
                        if (resultNode) {
                            resultNode.innerHTML = e.toString();
                        }
                    }
                });
                DomHelper.appendNode(mainNode, 'section', ['ms-5'], [], "", "odKiFunctions");
                const buttonResetNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-secondary', 'ms-2', 'mb-2'], [{ attr: 'id', value: 'kiPromptReset' }]);
                DomHelper.appendNode(buttonResetNode, 'i', ['fa-light', 'fa-broom-wide'], []);
                DomHelper.appendNode(buttonResetNode, 'span', [], [], 'Eingabe leeren');
                buttonResetNode.addEventListener('click', function (event) {
                    buttonNode.classList.remove('disabled');
                    inputNode.innerText = '';
                    resultNode.innerHTML = '';
                });
            }
        }
    });
}
function createButtonOpenKiFlex(injectNode, username, bearerToken, userPreferences, app) {
    const additionalClassList = [];
    const buttonNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    buttonNode.addEventListener('click', function (event) {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.add('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            const appConfig = JSON.parse(app.odAppConfig);
            if (DEBUG)
                console.log(appConfig);
            fullScreenNode.classList.remove('disabled');
            let sessionID = 'KI--' + Util.generateRandomDomId();
            createButtonClose(fullScreenNode, username, bearerToken, userPreferences);
            DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], appConfig.title ? appConfig.title : "Lernfeld KI");
            const kiPane = DomHelper.appendNode(fullScreenNode, 'section', ['odKiPane']);
            const mainNode = DomHelper.appendNode(kiPane, 'section', [], [], "", "odChatSection");
            const asideNode = DomHelper.appendNode(kiPane, 'aside', [], [], "", "odHistorySection");
            const configNode = DomHelper.appendNode(kiPane, 'aside', [], [], "", "odConfigSection");
            DomHelper.appendNode(configNode, 'h3', [], [], "Einstellungen");
            const resultNode = DomHelper.appendNode(mainNode, 'section', ['response-area'], [], "", "odKiResult");
            const promptNode = DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiPrompt");
            DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiHelp");
            const formNode = DomHelper.appendNode(promptNode, 'section', [], [{ attr: 'id', value: "kiPrompt" }, { attr: 'session', value: sessionID }]);
            const configFormNode = DomHelper.appendNode(configNode, 'section', [], [{ attr: 'id', value: "kiConfigForm" }]);
            const selectNode = DomHelper.appendSelect(configFormNode, 'kiConfigForm', [], 'model', 'Model', Util.getSelectOptions(appConfig.models), appConfig.models[0]);
            const inputPersonaNode = DomHelper.appendDivAsInput(configFormNode, [], 'persona', 'Persona', Util.replaceHTMLTags(appConfig.persona), 'odKiPersonaInput');
            const inputTemplateNode = DomHelper.appendDivAsInput(configFormNode, [], 'template', 'Template', Util.replaceHTMLTags(appConfig.template), 'odKiTemplateInput');
            const inputNode = DomHelper.appendNode(formNode, 'div', [], [
                { attr: 'type', value: 'text' },
                { attr: 'session', value: sessionID },
                { attr: 'placeholder', value: 'Stelle Deine Frage hier ...' },
                { attr: 'contenteditable', value: 'true' },
                { attr: 'id', value: 'odKiPromptInput' }
            ], 'Stelle Deine Frage hier ...');
            inputNode.addEventListener('focus', function (event) {
                if (inputNode.innerText === 'Stelle Deine Frage hier ...')
                    inputNode.innerText = '';
            });
            const buttonNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-primary', 'ms-1'], [{ attr: 'id', value: 'kiPromptSubmit' }]);
            DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-paper-plane'], []);
            buttonNode.addEventListener('click', function (event) {
                const inputPrompt = (inputNode).innerText;
                if (inputPrompt.length < 1)
                    return;
                const currentDate = new Date();
                const requestObject = { persona: Util.replaceEscapedHTMLTags(inputPersonaNode.innerText),
                    template: Util.replaceEscapedHTMLTags(inputTemplateNode.innerText),
                    model: selectNode.value,
                    history: [{
                            role: "user",
                            content: inputPrompt,
                            timestamp: currentDate.toISOString(),
                            tokenCount: 100
                        }] };
                let currentSession = inputNode.getAttribute('session') + '';
                appPartResultRender(resultNode, 'Du', inputPrompt, 'user');
                const currentHistory = storeChatSession(currentSession, requestObject.history[0]);
                const spinNode = DomHelper.appendNode(resultNode, 'i', ['fa-light', 'fa-spinner-third', 'fa-spin'], [], '', 'ki-spinner');
                inputNode.innerText = "";
                requestObject.history = currentHistory;
                const url = `/kibot/flex`;
                try {
                    sendBackendData('', url, 'POST', 'application/json', bearerToken, requestObject, function (response) {
                        const responseData = JSON.parse(response.target.response);
                        spinNode.remove();
                        storeChatSession(currentSession, responseData);
                        appPartResultRender(resultNode, responseData.role == 'system' ? 'RuDi#KI' : 'System', responseData.content, 'system', responseData.tokenCount);
                    });
                }
                catch (e) {
                    if (resultNode) {
                        resultNode.innerHTML = e.toString();
                        resultNode.scrollIntoView();
                    }
                }
            });
            DomHelper.appendNode(mainNode, 'section', ['ms-5'], [], "", "odKiFunctions");
            const buttonResetNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-secondary', 'ms-2', 'mb-2'], [{ attr: 'id', value: 'kiPromptReset' }]);
            DomHelper.appendNode(buttonResetNode, 'i', ['fa-light', 'fa-broom-wide'], []);
            DomHelper.appendNode(buttonResetNode, 'span', [], [], 'Chatverlauf leeren');
            const historyNode = DomHelper.appendNode(asideNode, 'section', ['history-area'], [], "", "odKiHistory");
            buttonResetNode.addEventListener('click', function (event) {
                renderHistory(historyNode);
                sessionID = 'KI--' + Util.generateRandomDomId();
                inputNode.innerText = '';
                inputNode.setAttribute('session', sessionID);
                resultNode.innerHTML = '';
            });
            renderHistory(historyNode);
        }
    });
}
function preventDAN(inputPrompt) {
    const forbiddenStrings = ["Do Anything Now", "jailbreak"];
    const inputLower = inputPrompt.toLowerCase();
    forbiddenStrings.forEach(item => {
        if (inputLower.includes(item)) {
            throw { message: "Sie stellen der KI gerade eine Aufgabe, die versucht Voreinstellungen, die Ihrer *Sicherheit* dienen zu umgehen. Diese Anfragen wird nicht bearbeitet." };
        }
    });
}
function handleClickOpen(injectNode, username, bearerToken, userPreferences, app) {
    const additionalClassList = [];
    let createCloseButton = true;
    const appGroupNode = document.getElementById('appGroups');
    if (appGroupNode)
        appGroupNode.classList.add('disabled');
    const appSingleNode = document.getElementById('singleApp');
    if (appSingleNode) {
        appSingleNode.classList.add('disabled');
        createCloseButton = false;
    }
    const fullScreenNode = document.getElementById('appFullscreen');
    if (fullScreenNode) {
        const appConfig = JSON.parse(app.odAppConfig);
        fullScreenNode.classList.remove('disabled');
        let sessionID = 'KI--' + Util.generateRandomDomId();
        if (createCloseButton)
            createButtonClose(fullScreenNode, username, bearerToken, userPreferences);
        DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], appConfig.title ? appConfig.title : "Lernfeld KI");
        const kiPane = DomHelper.appendNode(fullScreenNode, 'section', ['odKiPane']);
        const mainNode = DomHelper.appendNode(kiPane, 'section', [], [], "", "odChatSection");
        const asideNode = DomHelper.appendNode(kiPane, 'aside', [], [], "", "odHistorySection");
        const configNode = DomHelper.appendNode(kiPane, 'aside', [], [], "", "odConfigSection");
        const resultNode = DomHelper.appendNode(mainNode, 'section', ['response-area'], [], "", "odKiResult");
        const promptNode = DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiPrompt");
        DomHelper.appendNode(mainNode, 'section', additionalClassList, [], "", "odKiHelp");
        const formNode = DomHelper.appendNode(promptNode, 'section', [], [{ attr: 'id', value: "kiPrompt" }, { attr: 'session', value: sessionID }]);
        const inputNode = DomHelper.appendNode(formNode, 'div', [], [
            { attr: 'type', value: 'text' },
            { attr: 'session', value: sessionID },
            { attr: 'placeholder', value: 'Stelle Deine Frage hier ...' },
            { attr: 'contenteditable', value: 'true' },
            { attr: 'id', value: 'odKiPromptInput' }
        ], 'Stelle Deine Frage hier ...');
        inputNode.addEventListener('focus', function (event) {
            if (inputNode.innerText === 'Stelle Deine Frage hier ...')
                inputNode.innerText = '';
        });
        const buttonNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-primary', 'ms-1'], [{ attr: 'id', value: 'kiPromptSubmit' }]);
        DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        buttonNode.addEventListener('click', function (event) {
            const inputPrompt = (inputNode).innerText;
            if (inputPrompt.length < 1)
                return;
            try {
                preventDAN(inputPrompt);
            }
            catch (e) {
                appPartResultRender(resultNode, 'RuDi#Admin', e.message, 'admin', 0);
                return;
            }
            const currentDate = new Date();
            const requestObject = { persona: {
                    cn: appConfig.persona ? appConfig.persona : "kibp_assistent"
                },
                template: {
                    cn: appConfig.template ? appConfig.template : "kibt_completion"
                },
                model: {
                    cn: appConfig.model ? appConfig.model : "mistral-large-latest"
                },
                history: [{
                        role: "user",
                        content: inputPrompt,
                        timestamp: currentDate.toISOString(),
                        tokenCount: 100
                    }] };
            let currentSession = inputNode.getAttribute('session') + '';
            appPartResultRender(resultNode, 'Du', inputPrompt, 'user');
            const currentHistory = storeChatSession(currentSession, requestObject.history[0]);
            const spinNode = DomHelper.appendNode(resultNode, 'i', ['fa-light', 'fa-spinner-third', 'fa-spin'], [], '', 'ki-spinner');
            inputNode.innerText = "";
            requestObject.history = currentHistory;
            const url = `/kibot/completion`;
            try {
                sendBackendData('', url, 'POST', 'application/json', bearerToken, requestObject, function (response) {
                    const responseData = JSON.parse(response.target.response);
                    spinNode.remove();
                    storeChatSession(currentSession, responseData);
                    if (response.target.status == 200) {
                        appPartResultRender(resultNode, responseData.role == 'system' ? 'RuDi#KI' : 'System', responseData.content, 'system', responseData.tokenCount);
                    }
                    else {
                        appPartResultRender(resultNode, 'RuDi#Admin', responseData, 'admin', 0);
                    }
                });
            }
            catch (e) {
                if (resultNode) {
                    resultNode.innerHTML = e.toString();
                    resultNode.scrollIntoView();
                }
            }
        });
        DomHelper.appendNode(mainNode, 'section', ['ms-5'], [], "", "odKiFunctions");
        const buttonResetNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-secondary', 'ms-2', 'mb-2'], [{ attr: 'id', value: 'kiPromptReset' }]);
        DomHelper.appendNode(buttonResetNode, 'i', ['fa-light', 'fa-broom-wide'], []);
        DomHelper.appendNode(buttonResetNode, 'span', [], [], 'Chatverlauf leeren');
        const historyNode = DomHelper.appendNode(asideNode, 'section', ['history-area'], [], "", "odKiHistory");
        buttonResetNode.addEventListener('click', function (event) {
            renderHistory(historyNode);
            sessionID = 'KI--' + Util.generateRandomDomId();
            inputNode.innerText = '';
            inputNode.setAttribute('session', sessionID);
            resultNode.innerHTML = '';
        });
        renderHistory(historyNode);
    }
}
function createButtonClose(injectNode, username, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: 'id',
            value: ''
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'schließen');
    buttonNode.addEventListener('click', function (event) {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.remove('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            fullScreenNode.innerHTML = "";
            fullScreenNode.classList.add('disabled');
        }
    });
}
